import { useCallback } from 'react';
import { useRootStore } from 'store';

export const useFormPermissions = (data: any) => {
  const { appStore } = useRootStore();

  const calcUserCanView = useCallback(() => {
    let canView = false;
    let canViewReasoning = 'init false';

    if (appStore.isPlatformOwner || appStore.isCollector || appStore.isCollectorDriver) {
      canView = true;
      canViewReasoning = 'OK';
    } else if (appStore.isCollectionPoint) {
      canView = false;
      canViewReasoning = 'Δεν έχετε δικαίωμα προβολής αυτής της εγγραφής.';
    } else {
      canView = false;
      canViewReasoning = 'Δεν έχετε δικαίωμα προβολής αυτής της εγγραφής.';
    }

    return { canView, canViewReasoning };
  }, [appStore, data?.id]);
  const { canView, canViewReasoning } = calcUserCanView();

  return { canView, canViewReasoning };
};
